module.exports = __webpack_public_path__ + "static/media/btr-light.700fc1db.png";